import React from 'react';
import { useTranslate } from '../../../context/api-context/translations/use-translate';
import { SECONDARY_BTN, PRIMARY_BTN } from '../../../../common/constants/data-hooks';
import { classes } from './control-buttons.st.css';
import { Button } from './button/button';
export const ControlButtons = ({ isEdit, onCancel, onSubmit, publishButtonText }) => {
    const t = useTranslate();
    return (React.createElement("div", { className: classes.container },
        React.createElement(Button, { dataHook: SECONDARY_BTN, onClick: onCancel, priority: "secondary" }, t('comment-box.cancel')),
        React.createElement(Button, { dataHook: PRIMARY_BTN, onClick: onSubmit, priority: "primary" }, isEdit ? t('comment-box.save') : publishButtonText ?? t('comment-box.submit'))));
};
//# sourceMappingURL=control-buttons.js.map